<script>
    import { page } from '$app/stores';
    import { createEventDispatcher } from 'svelte';

    let className = '';
    export { className as class };
    export let link_class = '';
    export let sticky_headers = false;

    const dispatch = createEventDispatcher();
    let {
        courses = [],
        worksheets = [],
        is_school_admin = false,
        is_school_teacher = false,
        session
    } = $page.data;

    let path = $page.url.pathname;

    $: ({
        courses = [],
        worksheets = [],
        is_school_admin = false,
        is_school_teacher = false
    } = $page.data);

    let purchased_courses = (courses || []).filter(
        (course) => course?.purchased
    );

    let purchased_worksheets = (worksheets || []).filter(
        (worksheet) => worksheet?.purchased
    );

    function handle_close() {
        dispatch('close');
    }
</script>

{#if session}
    <div class={className}>
        {#if is_school_teacher}
            <div class="space-y-2">
                {#if is_school_admin}
                    <a
                        href="/my-school"
                        class="block px-4 py-2 rounded-lg
                {path === '/my-school'
                            ? 'bg-surface-highlight'
                            : path.startsWith('/my-school')
                            ? 'bg-surface-highlight link'
                            : 'link hover:bg-surface-highlight'}
            "
                        on:click={handle_close}
                    >
                        My School
                    </a>
                {/if}

                <a
                    href="/my-classrooms"
                    class="block px-4 py-2 rounded-lg
                {path === '/my-classrooms'
                        ? 'bg-surface-highlight'
                        : path.startsWith('/my-classrooms')
                        ? 'bg-surface-highlight link'
                        : 'link hover:bg-surface-highlight'}
            "
                    on:click={handle_close}
                >
                    My Classrooms
                </a>
            </div>
        {/if}

        {#if !is_school_teacher && !is_school_admin}
            <div class="space-y-2">
                <p
                    class="uppercase tracking-wider text-xs font-black pl-4 {sticky_headers
                        ? 'sticky top-0 z-10 pt-4 pb-1 w-full bg-black text-symbols-muted'
                        : 'opacity-70 mt-4'}"
>
                    My courses
                </p>

                {#if purchased_courses.length}
                    {#each purchased_courses as course (course.id)}
                        <a
                            href="/courses/{course.slug}/lessons"
                            class="block px-4 py-2 rounded-lg
                            {path === `/courses/${course.slug}`
                                ? 'bg-surface-highlight'
                                : path.startsWith(`/courses/${course.slug}`)
                                ? 'bg-surface-highlight link'
                                : 'link hover:bg-surface-highlight'}
                        "
                            on:click={handle_close}
                        >
                            {course.title}
                        </a>
                    {/each}
                {:else}
                    <p class="text-sm opacity-70 pl-4">
                        No purchased courses yet.
                    </p>
                {/if}
            </div>

            <div class="space-y-2">
                <p
                    class="uppercase tracking-wider text-xs font-black pl-4 {sticky_headers
                        ? 'sticky top-0 z-10 pt-4 w-full bg-black text-symbols-muted'
                        : 'opacity-70 mt-4'}"
>
                    My worksheets
                </p>

                {#if purchased_worksheets.length}
                    {#each purchased_worksheets as worksheet (worksheet.id)}
                        <a
                            href="/worksheets/{worksheet.slug}"
                            class="block px-4 py-2 rounded-lg
                            {path === `/worksheets/${worksheet.slug}`
                                ? 'bg-surface-highlight'
                                : path.startsWith(
                                      `/worksheets/${worksheet.slug}`
                                  )
                                ? 'bg-surface-highlight link'
                                : 'link hover:bg-surface-highlight'}"
                            on:click={handle_close}
                        >
                            {worksheet.title}
                        </a>
                    {/each}
                {:else}
                    <p class="text-sm opacity-70 pl-4">
                        No purchased worksheets yet.
                    </p>
                {/if}
            </div>
        {/if}
    </div>
{/if}
